import { LitElement, css, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';

@customElement('apt-box')
export class AptBox extends LitElement {
  @property({ type: Boolean })
  rounder = false;

  static override styles = css`
    :host {
      display: block;

      --font-color: #979797;
    }

    div.box {
      display: flex;
      min-width: 20px;
      min-height: 20px;
      width: max-content;
      height: max-content;
      box-sizing: border-box;

      border: 1px solid var(--font-color);

      border-radius: 5px;
      overflow: hidden;
    }

    div.box.rounder-corners {
      border-radius: 10px;
    }
  `;

  override render() {
    return html`<div
      class="box ${classMap({
        'rounder-corners': this.rounder,
      })}"
    >
      <slot></slot>
    </div>`;
  }
}
